module.exports = __webpack_public_path__ + "img/f(x)DexHomepage@2x.c94f75c7.jpg";